import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import MoneyZakatTable from './MoneyZakatTable';
import { SERVER_URL } from '../ConstantsEN';
import { Money_Zakat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = `Money Zakat Calculator 2026 - Money Zakat Nisab Calculator`;
const DESCRIPTION = 'The Money Zakat Calculator is a tool used to calculate the amount of Zakat due on cash, savings, and investments. This calculator is used to calculate the financial amount that must be paid as Zakat on various types of assets.';
const KEYWORDS = 'Money Zakat, Zakat Amount, Zakat Nisab, Zakat on Cash, Zakat Calculator, Zakat Calculation, Zakat on Savings, Islamic Finance';
const OG_URL = 'https://do-calculate.com/calculator/en/money-zakat/';
const apiEndpoint = `${SERVER_URL}/${Money_Zakat_EndPoint}`;
function MoneyZakatCalculator() {
    const [amount, setAmount] = useState('');
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [gramPriceSilver, setGramPriceSilver] = useState(0);
    const [result, setResult] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [thresholdType, setThresholdType] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const handleThresholdTypeChange = (event) => {
        const newThresholdType = event.target.value;
        setThresholdType(newThresholdType);
        if (newThresholdType === "gold") {
            setGramPriceSilver(0);
        } else if (newThresholdType === "silver") {
            setGramPriceGold(0);
        }
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleAmountChange = (event) => {
        setAmount(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const handleGramPriceSilverChange = (event) => {
        setGramPriceSilver(event.target.value);
    };
    const calculateMoneyZakat = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ amount, yearType, gramPriceGold, gramPriceSilver }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setResult(data.result);
                setClassification(data.result.classification);
            } else {
                setResult(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Calculate Money Zakat</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Money Zakat Calculator is a tool used to calculate the amount of Zakat due on cash, savings, and investments. This calculator is used to calculate the financial amount that must be paid as Zakat on various types of assets.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Money Zakat Calculator</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Year Type</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id='gregorian'
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Gregorian
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id='hijri'
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijri
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor="amoutNumber" className="form-label ms-2">Total Amount</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="amoutNumber"
                                        value={amount}
                                        onChange={handleAmountChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Threshold Type</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="gold"
                                            id="gold"
                                            checked={thresholdType === "gold"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gold">
                                            Gold
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="thresholdType"
                                            value="silver"
                                            id="silver"
                                            checked={thresholdType === "silver"}
                                            onChange={handleThresholdTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="silver">
                                            Silver
                                        </label>
                                    </div>
                                </div>
                                <br />
                                {thresholdType === "gold" && (
                                    <div className="form-group d-flex align-items-center">
                                        <b>
                                            <label htmlFor="gramPriceGoldNumber" className="form-label ms-2">Gold Price per Gram (24 Karat)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceGoldNumber"
                                            value={gramPriceGold}
                                            onChange={handleGramPriceGoldChange}
                                            className="form-control ml-2"
                                            style={{ width: '75px' }}
                                        />
                                    </div>
                                )}
                                {thresholdType === "silver" && (
                                    <div className="form-group d-flex align-items-center">
                                        <b>
                                            <label htmlFor='gramPriceSilverNumber' className="form-label ms-2">Silver Price per Gram (99.9 Purity)</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="gramPriceSilverNumber"
                                            value={gramPriceSilver}
                                            onChange={handleGramPriceSilverChange}
                                            className="form-control ml-2"
                                            style={{ width: '75px' }}
                                        />
                                    </div>
                                )}
                                <br />                                <hr />
                                <button
                                    className="btn btn-success"
                                    style={{ fontSize: '20px' }}
                                    onClick={calculateMoneyZakat}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                {result && (
                                    <div>
                                        <h4><div className="p-3 mb-2 bg-success text-white">Results:</div></h4>
                                        <hr />
                                        <MoneyZakatTable result={result}></MoneyZakatTable>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Wealth Zakat Calculator</div>
                            <div className="info-section-body">
                                <br />
                                <div>
                                    <h2 style={{ fontSize: '15px' }}>Wealth Zakat Threshold 2026 - Amount of Required Wealth Zakat</h2>
                                    The Wealth Zakat calculator is based on the wealth thresholds set in Islamic Sharia. For example, the threshold for Hijri Zakat requires the presence of wealth equivalent to 85 grams of gold, while the threshold for Gregorian Zakat requires wealth equivalent to 595 grams of silver. If the value of your wealth exceeds these thresholds, then you are obligated to pay Zakat.
                                    <br />                                    <h2 style={{ fontSize: '15px' }}>How to Calculate Wealth Zakat</h2>
                                    The calculator calculates the amount of Zakat due based on the input values and the Sharia laws related to Zakat. If the value of your wealth exceeds the specified threshold according to the selected calendar and the prices of gold and silver, the calculator will calculate the specified Zakat percentage (2.5% in Hijri Zakat and 2.577% in Gregorian Zakat) and determine the Zakat compliance status as "Yes" while calculating the due amount.
                                    <br />                                    The calculator returns an object containing Zakat information, including Zakat compliance status ("Yes" or "No"), the due Zakat amount, and the minimum wealth eligible for Zakat.
                                    <br />                                    <div className='p-3 mb-2 bg-info  '>
                                        The gold considered in determining the Zakat threshold is 24 karats because 21, 18, and other karats are not pure gold; they are mixed with other metals and alloys. If someone has gold of another karat, such as 22, 21, 18, 14, 10, or any other, Zakat is obligatory only on the pure part of it.
                                    </div>
                                    <br />
                                    <hr />
                                    <b>Source: </b>
                                    <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/">
                                        Islamic Relief Worldwide
                                    </a> <br />
                                    <b>Last Reviewed On: </b>
                                    02/07/2023
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MoneyZakatCalculator;
